import * as DarkReader from "darkreader";
import {
    gfile,
    ggroup,
    gselectedgroup,
    gConf,
    empty_gen_opt,
    guser,
    gactivecomp,
    gdynfilter,
    gqasimplified,
    empty_contenttype_config,
    empty_convo_config,
    empty_extraction_field_list,
    empty_spo_config,
    empty_line_config,
    gfileuserselect,
    gsuggestedquestions,
    campaignidnamepair
} from "../../interfaces";
import {
    answerCardHTML,
    assistantCodes,
    spaceModPrepend,
    itemCachePrepend,
    defaultGreetingContent,
    get_typed_greeting_message,
    noContentNoAccessGreetingContent,
    campaignUserSelectPerSpace
} from "../../lsts";
import {
    ChatAppResponse,
    ChatAppResponseOrError,
    ChatAppRequest,
    ResponseMessage,
    ResponseChoice,
    RetrievalMode
} from "../../api";
import {
    removeEnclosingQuotes,
    shuffleArray,
    encodeHTML
} from "../../util_glob";
import { isItemReadyDocStatusUnly } from "../../components/detailedList/detailedMdls";

export const hasSentenceEnder = (txt: string) => /[.!?:]/.test(txt);

export const hasSentenceEnderPlusComma = (txt: string) => /[.!?:]/.test(txt);

export const emptyIsPDFOpen = {
    defaultFile: "",
    startPage: "1",
    isOpen: false,
    searchString: "",
    contentlist: [
        {
            fileid: "",
            srcPageNum: 0,
            srcText: "",
            destPageId: 0,
            destPageNum: 0
        }
    ],
    pagemap: {},
    fileId: "",
    refPageNum: "",
    isCitation: false,
    rndo: "",
    activeGroupId: "",
    fileList: [],
    fl: undefined
};

export const emptyIsPDFDiffOpen = {
    defaultFile1: "",
    defaultFile2: "",
    isOpen: false,
    searchString: "",
    fileId1: "",
    fileId2: "",
    refPageNum: "",
    isCitation: false,
    rndo: "",
    activeGroupId: "",
    fileList: [],
    fl1: undefined,
    fl2: undefined,
    diff: undefined
};

export const groupListToSelectedGroup = (group?: ggroup) => (selectedgroup: gselectedgroup) => {
    return {
        selectionId: group ? group.groupid || "" : "",
        selectionText: group ? group.groupname || "" : "",
        permissionlevel: group ? group.permissionlevel || 0 : 0,
        description: group ? group.description || "" : "",
        sharewithcode: group ? group.sharewithcode || false : false,
        filecount: group ? group.filecount || 0 : 0,
        custaiinst: group ? group.custaiinst || "" : "",
        custgreetingmessage: group ? group.custgreetingmessage || "" : "",
        isintegrateddata: group ? group.isintegrateddata || 0 : 0,
        allowyoutube: group ? group.allowyoutube ?? 1 : 1,
        allowweb: group ? group.allowweb ?? 1 : 1,
        enabledocaudio: group ? group.enabledocaudio ?? 1 : 1,
        retrievecount: group ? group.retrievecount ?? 5 : 5,
        sectionoverlap: group ? group.sectionoverlap ?? 200 : 200,
        maxsectionlength: group ? group.maxsectionlength ?? 3000 : 3000,
        sentencesearchlimit: group ? group.sentencesearchlimit ?? 200 : 200,
        inscope: group ? group.inscope ?? 1 : 1,
        temperature: group ? group.temperature ?? 0.7 : 0.7,
        responsetokenlimit: group ? group.responsetokenlimit ?? 3024 : 3024,
        disablecitationhighlighting: group ? group.disablecitationhighlighting ?? 0 : 0,
        strictness: group ? group.strictness ?? 3 : 3,
        invoicesgroup: group ? group.invoicesgroup ?? 0 : 0,
        questionsuggestions: group ? group.questionsuggestions ?? 0 : 0,
        nosidebysideview: group ? group.nosidebysideview ?? 0 : 0,
        isowner: group ? group.isowner ?? 0 : 0,
        dailymsgs: group ? group.dailymsgs ?? 0 : 0,
        premiumby: group ? group.premiumby ?? "" : "",
        oid: group ? group.oid ?? 0 : 0,
        tier: group ? group.tier ?? 0 : 0,
        premwhen: group ? group.premwhen ?? 0 : 0,
        companyid: group ? group.companyid ?? "" : "",
        apikey: group ? group.apikey ?? "" : "",
        producecontentlist: group ? group.producecontentlist ?? 0 : 0,
        producequestions: group ? group.producequestions ?? 0 : 0,
        assistanttype: group ? group.assistanttype ?? "anya" : "anya",
        showexamplequestionsonstart: group ? group.showexamplequestionsonstart ?? 0 : 0,
        headerimageurl: group ? group.headerimageurl ?? "" : "",
        manualquestionsuggestions: group ? group.manualquestionsuggestions ?? "" : "",
        usedocintel: group ? group.usedocintel ?? 0 : 0,
        extractionfieldlist: group ? group.extractionfieldlist ?? empty_extraction_field_list : empty_extraction_field_list,
        allowaudiodocentry: group ? group.allowaudiodocentry ?? 0 : 0,
        forceocr: group ? group.forceocr ?? 0 : 0,
        allowvideofiles: group ? group.allowvideofiles ?? 0 : 0,
        convomode: group ? group.convomode ?? 0 : 0,
        convolang: group ? group.convolang ?? "auto" : "auto",
        hideaisearch: group ? group.hideaisearch ?? 0 : 0,
        docextractionconfig: group ? group.docextractionconfig ?? [] : [],
        docextractionuseauto: group ? group.docextractionuseauto ?? 0 : 0,
        landingpage: group ? group.landingpage ?? 0 : 0,
        urllinkextraction: group ? group.urllinkextraction ?? 0 : 0,
        spo_config: group ? group.spo_config ?? empty_spo_config : empty_spo_config,
        convo_config: group ? group.convo_config ?? empty_convo_config : empty_convo_config,
        contenttype_config: group ? group.contenttype_config ?? empty_contenttype_config : empty_contenttype_config,
        line_config: group ? group.line_config ?? empty_line_config : empty_line_config,
        aiquestionslang: group ? group.aiquestionslang ?? "" : "",
        perchunkmeta: group ? group.perchunkmeta ?? 0 : 0,
        pdfcontentlist: group ? group.pdfcontentlist ?? 0 : 0,
        showchartsinuni: group ? group.showchartsinuni ?? 0 : 0,
        enhance_img: group ? group.enhance_img ?? 0 : 0,
        usenewmodel: group ? group.usenewmodel ?? 0 : 0,
        uselatestretrieval: group ? group.uselatestretrieval ?? 0 : 0,
        useapproval: group ? group.useapproval ?? 0 : 0,
        allowaudiofiles: group ? group.allowaudiofiles ?? 0 : 0,
        landonmanage: group ? group.landonmanage ?? 0 : 0,
        itemupd: group ? group.itemupd ?? "" : "",
        viewerscanupload: group ? group.viewerscanupload ?? 0 : 0,
        hideroottabs: group ? group.hideroottabs ?? 0 : 0,
        dontloadlastconvo: group ? group.dontloadlastconvo ?? 0 : 0,
        splitinv: group ? group.splitinv ?? 0 : 0,
        allowsimpleconvo: group ? group.allowsimpleconvo ?? 0 : 0,
        allowgroupconnect: group ? group.allowgroupconnect ?? 0 : 0,
        campaigns_enabled: group ? group.campaigns_enabled ?? 0 : 0,
        def_campaign_id: group ? group.def_campaign_id ?? '' : '',
        camp_join: group && group.camp_join ? (group.camp_join as string).split(";").map((c: string) => {
            const [id, name] = c.split(",");
            return { id, name } as campaignidnamepair;
        }) : [],
        gen_opt: group ? group.gen_opt ?? empty_gen_opt : empty_gen_opt
    };
};

export const getTokenMail = (token: any) => {
    return token.idTokenClaims?.emails?.length > 0 ? token.idTokenClaims?.emails[0] : token.idTokenClaims?.email;
};

// dark mode
export const handleIsDark = (isDark: boolean) => {
    try {
        if (isDark == true) {
            DarkReader.setFetchMethod(window.fetch);
            DarkReader.enable({
                mode: 1,
                brightness: 100,
                contrast: 100,
                grayscale: 0,
                sepia: 0,
                useFont: false,
                fontFamily: "Urbanist, Roboto",
                textStroke: 0,
                darkSchemeBackgroundColor: "#252525",
                darkSchemeTextColor: "#e8e6e3",
                lightSchemeBackgroundColor: "#dcdad7",
                lightSchemeTextColor: "#181a1b",
                scrollbarColor: "auto",
                selectionColor: "auto",
                styleSystemControls: true
            });
        } else {
            DarkReader.disable();
        }
    } catch (e) {
        console.log("‹errr_dm›");
    }
};

// file cache related
export const getCacheLastMod = (flCache?: gfile[]) => {
    return flCache?.reduce((latest, current) => {
        const currentDate = new Date(current.modified);
        return currentDate > new Date(latest.modified) ? current : latest;
    });
};

export const getLastMod = (dateList?: any[]) => {
    /**  Returns the latest date from a list of dates */
    return dateList?.reduce((latest, current) => {
        return current > latest ? current : latest;
    });
};

// citations related
export const extractPageValue = (fileCitationPath: string) => {
    const match = fileCitationPath.match(/page=(\d+)/);
    return match ? match[1] : "";
};

// citations related
export const extractFileIDValue = (fP: string) => {
    let fid = "";
    const fidSplit = fP ? fP.split("_fid=") : [];
    if (fidSplit.length > 1) {
        return fidSplit[1].trim();
    } else {
        return "";
    }
};

// initial load related
export const getTokenAccountID = (token: any) => {
    return token.uniqueId || token.localAccountId || token.oid;
};

export const cleanFileIDString = (fileP: string) => {
    // ViomeRecommendations_F2849CD32684.pdf#page=6_fid=379, ViomeRecommendations_F2849CD32684.pdf_page=31_fid=379
    return fileP.replace("#", "_");
};

export const checkWeAreInGeneralPlace = (isLib: string) => {
    return isLib == "grp" || isLib == "acc" || isLib == "adm";
};

export const getCitationFileId = (fileName: string, fileId: string, filePage: string = "1") => {
    return `${fileName}#page=${filePage}_fid=${fileId}`;
};

export const getFileContentList = (file: gfile) => {
    try {
        let prsd = JSON.parse(file.contentlistai || "{content_table:[]}")?.content_table;
        return prsd || [];
    } catch (e) {
        return [];
    }
};

export const joinShortSentences = (arr: string[]) => {
    const result = [];
    for (let i = 0; i < arr.length; i++) {
        const current = arr[i];
        if (current.length < 5) {
            if (i === 0 && arr.length > 1) {
                // IF FIRST, COMBINE WITH NEXT
                arr[i + 1] = current + "" + arr[i + 1];
            } else if (result.length > 0) {
                // NOT FIRST, COMBINE WITH PREVIOUS
                result[result.length - 1] += "" + current;
            }
        } else {
            result.push(current);
        }
    }
    return result;
};

export const removeRefTags = (txt: string) => {
    return txt.replace(/\[doc\d*[\s\S]*?(?:\]|$)/g, "");
};

export const removeRefTagsClosedOnly = (txt: string) => {
    // matches [doc1 integrated data tags
    return txt.replace(/\[doc\d*[\s\S]*?\]/g, "");
};

export const splitIntoSentences = (txt: string) => {
    try {
        return txt
            .replace(/\.\.\./g, "§") // REPLACE ... WITH PLACEHOLDER
            .match(/[^.!?:]+[.!?:]+|[^.!?:]+$/g) // SPLIT INTO SENTENCES
            ?.map((s: any) => s.replace(/§/g, "...").trim()) // Restore ...
            .filter(Boolean); // REMOVE EMPTY STRINGS
    } catch {
        return [];
    }
};

export const splitIntoSentencesPlusCommas = (txt: string) => {
    try {
        return txt
            .replace(/\.\.\./g, "§") // Replace "..." with a placeholder
            .match(/[^.!?:,]+[.!?:,]+|[^.!?:,]+$/g) // Updated regex to include commas
            ?.map((s: any) => s.replace(/§/g, "...").trim()) // Restore "..." and trim
            .filter(Boolean); // Remove empty strings
    } catch {
        return [];
    }
};

export const getChunkRandomId = () => {
    return Date.now().toString() + Math.random().toString(36).substring(2, 8);
};

export const endsWithPunctuation = (str: string) => {
    return str.endsWith(".") || str.endsWith("!") || str.endsWith("?");
};

export const handleNonStreamChat = async (response: any, question: any, answers: [user: string, response: ChatAppResponse][]) => {
    const ResponseContext = await response.json();
    const joinedAnswers = ResponseContext.data_points
        .map((a: string) => {
            const [documentName, content] = a.split(/:(.+)/);
            return `[${documentName}]<div>${content}</div>`;
        })
        .join("");
    const emptyResponseChoice: ResponseChoice = {
        index: 0,
        message: { content: joinedAnswers, role: "assistant" },
        context: {
            thoughts: "",
            data_points: ResponseContext.data_points_captions,
            data_points_captions: ResponseContext.data_points_captions,
            data_points_integrated: ResponseContext.data_points_integrated,
            followup_questions: [],
            response_tokens: 0,
            prompt_tokens: 0,
            message_type: "",
            sql_query: "",
            chartjs_json: "",
            chart_regen: [],
            sql_result: "",
            no_info_message: {},
            collected_data: {}

        },
        session_state: answers.length ? answers[answers.length - 1][1].choices[0].session_state : null
    };
    const emptyChatAppResponse: ChatAppResponse = {
        choices: [emptyResponseChoice],
        datecode: new Date().toISOString(),
        interaction_guid: "",
        pos: null,
        chartsel: 0

    };
    const parsedResponse: ChatAppResponseOrError = emptyChatAppResponse;
    if (response.status > 299 || !response.ok) throw Error(parsedResponse.error || "Unknown error");
    return { question: question, parsedResponse: parsedResponse };
};

// ANCHOR[id=ovrrds] - overrides for response generation
export const get_ovrrds = (
    selectedGroup: gselectedgroup,
    config: gConf,
    user: guser,
    activeComp: gactivecomp,
    activeConvoKey: string,
    dynFiltering: gdynfilter,
    additional_string_data: string,
    current_intent: string,
    msg_ovvride: string,
    fid_select: string[]
) => {
    let flen = window.globalFL?.length || 0;
    let requstForInfo = false;
    if (window.globalRequestForInfo && window.globalRequestForInfo == true) {
        requstForInfo = true;
        window.globalRequestForInfo = false;
    }
    let scenarios      = {};
    let response_ovrrd = msg_ovvride;

    let camp_data: any[] = []
    let camp_id = "";
    if (selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.campaigns_enabled == 1) {
        if (window.globalCampDataArr && window.globalCampDataArr.length > 0) {
            let campFidData = window.globalCampDataArr[0]
            camp_data = window.globalFL
                .filter((file: gfile) => campFidData.map(String).includes(String(file.fileid)))
                .map((file: gfile) => ({
                    fileid: file.fileid,
                    name: file.name,
                    invoicedata: file.invoicedata
                })
            );
            import.meta.env.DEV && console.log("‹camp_data›", camp_data);
            camp_id = window.globalCampDataArr[1] || "";
        }
    }


    return {
        // conf - user prompt
        prompt_template: selectedGroup.custaiinst,
        // legacy
        exclude_category: undefined,
        // adv - dynamic src filter [used?]
        include_category: dynFiltering.category.length === 0 ? undefined : dynFiltering.category,
        // ai retrieval lim
        top: selectedGroup.retrievecount,
        // op - semantic or other
        retrieval_mode: config.retrievalMode as RetrievalMode,
        // conf - use search result highlights as data source [legacy?]
        highlights_as_source: config.useHighlightsAsSource,
        // conf -  exampe questions after answer
        suggest_followup_questions: selectedGroup.questionsuggestions == 1 ? true : undefined,
        // op - legacy
        use_oid_security_filter: false,
        // op - legacy
        use_groups_security_filter: false,
        // op - group id [not a mistake]
        user_id: dynFiltering.groups,
        // ai - allow external data
        inscope: selectedGroup.inscope,
        // conf - creativity
        temperature: selectedGroup.temperature,
        // conf - out token lim [applicable conditionally]
        responsetokenlimit: selectedGroup.responsetokenlimit,
        // conf - no highlight snippets in text
        disablecitationhighlighting: selectedGroup.disablecitationhighlighting,
        // conf  - ai search strictness
        strictness: selectedGroup.strictness,
        // op - comp id
        companyid: activeComp.companyid,
        // op - oid
        oid: selectedGroup.oid,
        // conf  - is data assistant
        invoicesgroup: selectedGroup.invoicesgroup,
        // op - userid
        uid: user.userId,
        // op - assistant type
        assistanttype: selectedGroup.assistanttype,
        // op - data processing extraction config
        docextractionconfig: selectedGroup.assistanttype == assistantCodes.cca ? selectedGroup.docextractionconfig : undefined,
        // adv - does the user request info [legacy?]
        requstforinfo: requstForInfo,
        // cca - convo id for cca
        convoid: activeConvoKey,
        // cca - convo iteration
        convostamp: window.convoPerfOnRecogFin,
        // cca - enhanced data recog hints
        kasd: additional_string_data,
        // cca - current intent
        current_intent: current_intent,
        // cca responce override
        response_ovrrd: response_ovrrd,
        // cca - scenarios config
        scenarios: scenarios,
        // cca - active scenario now
        active_scenario_id: window.global_active_scenario_id,
        // cca - initiator source
        src: "web",
        // adv - scoped knowledge - selected items
        fid_select: fid_select,
        // universal content -  show charts
        showchartsinuni: selectedGroup.showchartsinuni,
        // op - item count
        f_count: window.globalFL?.length || 0,
        // adv - scoped knowledge - file ids up to 20 len
        fids: flen > 0 && flen < 20 ? (window.globalFL?.map((f: gfile) => f.fileid) || []) : [],
        // conf - 5 model opt-in
        usenewmodel: selectedGroup.usenewmodel,
        // conf - advanced custom v2 retrieval opt-in
        uselatestretrieval: selectedGroup.uselatestretrieval || 0,
        ...(selectedGroup.assistanttype == assistantCodes.cca ? {
            // are campaigns enabled for this group - cca
            campaigns_enabled: selectedGroup.campaigns_enabled,
            // in cca types sends  default campaign to load
            def_campaign_id: selectedGroup.def_campaign_id,
         } : {}),
         // line / chat
         cli_src_str: 'chat', // web chat
         // global campaign id
         global_u_cmp_obj: window?.global_u_cmp_obj || null,
         // general group config
         gen_opt: selectedGroup.gen_opt || empty_gen_opt,
         // target id (cca convodata related)
        target_id: user.userId,
        // camp id from file data
        camp_id: camp_id,
        //campaign relative structured file data
        ...(selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.campaigns_enabled == 1 && camp_data.length > 0 ? { camp_data: camp_data } : {}),

    };
};

export const callerNameToInt = (callerName: string) => {
    switch (callerName) {
        case "user":
            return 1;
        case "assistant":
            return 2;
        default: return 0;
    }
};

export const determineCategoryAndGroups = (selectedGroup: gselectedgroup, includeCategory: string, includeCategoryGroups: string) => {
    let cat = '';
    let groups = '';
    if (selectedGroup.selectionId == 'FileSelect') {
        cat = includeCategory; // set file filter to selected files
        groups = includeCategoryGroups; // set group filter to selected file's groups
    } else {
        cat = '';
        groups = selectedGroup.selectionId;
    }
    return { category: cat, groups: groups };
};

export const prep_question_and_answers_list = (answers: [user: string, response: ChatAppResponse][]): gqasimplified[] => {
    let question_answer_simplified_list: gqasimplified[] = [];
    for (let i = 0; i < answers.length; i++) {
        let question = answers[i][0];
        let answer = answers[i][1];
        question_answer_simplified_list.push({
            role: "user",
            content: question
        });
        question_answer_simplified_list.push({
            role: "assistant",
            content: answer.choices[0].message.content
        });
    }
    return question_answer_simplified_list;
};

export const preserve_convo_collected_data = (askResponse: ChatAppResponse) => {
    if (!window.global_convo_collected) window.global_convo_collected = {};

    if (askResponse?.choices[0]?.context?.collected_data) {
        try {
            let collected_data = JSON.parse(askResponse?.choices[0]?.context?.collected_data);
            window.global_gen_tr = collected_data;
            for (const key of Object.keys(collected_data)) {
                window.global_convo_collected[key] = collected_data[key];
            }
            setConvoV2State("‹global_convo_collected›", window.global_convo_collected);
        } catch (e) {
            console.log("errr parsing collected data:", e);
        }
    }
};

export const create_chatapprequest = (
    question: string,
    answers: [user: string, response: ChatAppResponse][],
    ovrrds: any,
    inplaceupdate: boolean
): ChatAppRequest => {
    let messages: ResponseMessage[] = (inplaceupdate == true ? answers.slice(0, answers.length - 1) : answers).flatMap(a => [
        { content: a[0], role: "user" },
        { content: a[1].choices[0].message.content, role: "assistant" }
    ]);
    let contnt = inplaceupdate == true ? answers[answers.length - 1][0] + question : question;
    const request: ChatAppRequest = {
        messages: [...messages, { content: contnt, role: "user" }],
        stream: true,
        use_integrated_search: true,
        context: { overrides: ovrrds },
        session_state: answers.length
            ? inplaceupdate == false
                ? answers[answers.length - 1]?.[1]?.choices[0].session_state
                : answers.length > 2
                ? answers[answers.length - 2]?.[1]?.choices[0].session_state
                : answers.length > 0
                ? answers[answers.length - 1]?.[1]?.choices[0].session_state
                : null
            : null
    };
    return request;
};

export const setConvoV2State = (target: string, value: any, option?: string) => {
    switch (target) {
        case "global_expected_next_user_response_type":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_expected_next_user_response_type = value;
            break;
        case "global_active_scenario_id":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_active_scenario_id = value;
            break;
        case "global_convo_last_response_finish":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_last_response_finish = value;
            break;
        case "global_convo_cadance_stamp":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_cadance_stamp = value;
            break;
        case "globalConvPerfRecog":
            if (window?.cca?.conversation_state) window.cca.conversation_state.globalConvPerfRecog = value;
            break;
        case "global_simple_convo_list":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_simple_convo_list = value;
            break;
        case "global_convo_last_speech_start":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_last_speech_start = value;
            break;
        case "global_convo_last_speech_finish":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_last_speech_finish = value;
            break;
        case "global_convo_last_response_start":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_last_response_start = value;
            break;
        case "global_convo_collected":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_convo_collected = value;
            break;
        case "globalConvoKey":
            if (window?.cca?.conversation_state) window.cca.conversation_state.globalConvoKey = value;
            break;
        case "convoPerfOnRecogFin":
            if (window?.cca?.conversation_state) window.cca.conversation_state.convoPerfOnRecogFin = value;
            break;
        case "global_is_tracking_silence":
            if (window?.cca?.conversation_state) window.cca.conversation_state.global_is_tracking_silence = value;
            break;
        case "last_partial_result":
            if (window?.cca) window.cca.last_partial_result = value;
            break;
        case "global_convo_rollon_recognizing":
            if (window?.cca?.conversation_state) {
                if (!window.cca.conversation_state.global_convo_rollon_recognizing) window.cca.conversation_state.global_convo_rollon_recognizing = [];
                if (option == "push") window.cca.conversation_state.global_convo_rollon_recognizing.push(value);
                if (option == "set") window.cca.conversation_state.global_convo_rollon_recognizing = value;
            }
            break;
        case "global_run_on_sentence":
            if (window?.cca?.conversation_state) {
                if (!window.cca.conversation_state.global_run_on_sentence)
                    window.cca.conversation_state.global_run_on_sentence = { segments: [], recognized: [] };
                if (option == "segments") window.cca.conversation_state.global_run_on_sentence.segments.push(value);
                if (option == "recognized") window.cca.conversation_state.global_run_on_sentence.recognized.push(value);
                if (option == "set_segments") window.cca.conversation_state.global_run_on_sentence.segments = value;
                if (option == "set_recognized") window.cca.conversation_state.global_run_on_sentence.recognized = value;
            }
            break;
        default:
            break;
    }
};

export const parseInvoiceDataFromFiles = (flCache: any) => {
    for (let i = 0; i < flCache.length; i++) {
        if (flCache[i].invoicedata) {
            flCache[i].invoicedata = typeof flCache[i]?.invoicedata === "string" ? JSON.parse(removeEnclosingQuotes(flCache[i]?.invoicedata || '"[]"')) : flCache[i]?.invoicedata;

            if (flCache[i].doc_category) { // add to data, parent props
                try{
                    flCache[i].invoicedata["doc_category"] = flCache[i].doc_category || "";
                } catch(e){
                    console.log("errr parsing doc category for invoice data:", e);
                }
            }
        }

        if (flCache[i].aiinteractions){
            flCache[i].aiinteractions = flCache[i]?.aiinteractions === "string" ? [flCache[i]?.aiinteractions.split(",")] : flCache[i]?.aiinteractions.split(",");
        }

    }

    return flCache;
};

export const safeJsonUnwrap = (input: string) => {
    try {
        // First attempt: parse as-is
        return JSON.parse(input);
    } catch (e1) {
        try {
            // Second attempt: unwrap and clean, then double-parse
            const cleaned = input?.replace(/^"(.*)"$/, "$1"); // remove outer quotes
            return JSON.parse(JSON.parse(`${cleaned}`));
        } catch (e2) {
            console.log("jsonUnwrap failed:", e2);
            return {};
        }
    }
};

export const onXplrrPDFModelDiffClosed = () => {
    window.globalHiglightFound = false;
    window.globalWigglePixel = 0;
};

export const transformFileSelection = (filelist: gfile[], fidSel: string[]): gfileuserselect[] => {

    let fidSelStr = fidSel.map(f => f.toString());
    return filelist.map(file => ({
        fileid: file.fileid,
        name: file.name,
        modified: file.modified,
        size: file.size,
        doc_category: file.doc_category || "",
        doc_status: isItemReadyDocStatusUnly(file.docstatus),
        tag: file.tag || "",
        selected: fidSelStr.includes(file.fileid.toString())
    }));
};




export const getUrlPathSegment = (level: number) => {
    // get url path segment based on level from the end
    let hshpat = window.location.hash.split("/");
    try{
        return hshpat[hshpat.length - level]
    } catch(e){
        return "";
    }
}





// on xplrr pdf model closed
export const onXplrrPDFModelClosed = () => {
    window.globalHiglightFound = false;
    window.globalWigglePixel = 0;


};

// preserve local config
export const preserveLocalConfig = (config:any, key:string) => {
    let configString = JSON.stringify(config);
    localStorage.setItem(key, configString);
};

// create suggested questions HTML
export const createSuggestedQuestionsHTML = (selectedGroup: gselectedgroup, suggestedQuestions:gsuggestedquestions[] | undefined) => {
    let defaultContent = selectedGroup.filecount > 0 ? "" : selectedGroup.permissionlevel >= 2 ? get_typed_greeting_message(selectedGroup.assistanttype) : noContentNoAccessGreetingContent;
    const allQuestions = (suggestedQuestions || [])
        .map((q: any) => q.suggestedquestions)
        .join(";")
        .split(";")
        .filter((question: string) => question !== "" && question != null && question !== undefined);

    if (allQuestions && allQuestions.length > 0 && selectedGroup?.showexamplequestionsonstart == 1) {
        let selectedQuestions = shuffleArray([...allQuestions]).slice(0, 3);
        if (selectedGroup.manualquestionsuggestions != "") {
            selectedQuestions = [...selectedGroup.manualquestionsuggestions.split(";"), ...selectedQuestions];
        }
        const html = selectedQuestions.map(question =>
            answerCardHTML
                .replace(/{kgnf_replace}/g, encodeHTML(question))
                .replace(selectedGroup.assistanttype == assistantCodes.cca ? ">Suggested Question<" : "‾‾‾ ‾", "> Start a Call <")
        );
        return `<div horizontal wrap tokens=5 class='answerCardContainer'>${html.join("")}</div>`;
    } else if (selectedGroup.manualquestionsuggestions != "") {
        const html = selectedGroup.manualquestionsuggestions
            .split(";")
            .map(question =>
                answerCardHTML
                    .replace(/{kgnf_replace}/g, encodeHTML(question))
                    .replace(selectedGroup.assistanttype == assistantCodes.cca ? ">Suggested Question<" : "‾‾‾ ‾", "> Start a Call <")
            );
        return `<div horizontal wrap tokens=5 class='answerCardContainer'>${html.join("")}</div>`;
    } else {
        return defaultContent;
    }
};

export const startConvoEvntDispatch =  ( param: string ) => {
    let convoButton = document.getElementById( "kgnfconvostart" );
    if ( convoButton )
    {
        ( convoButton as any ).dispatchEvent(
            new MouseEvent( "click", {
                bubbles: true,
                cancelable: true,
                view: window
            } )
        );
        setTimeout( () =>
        {
            let convoInput = document.getElementById( "kgnfqinputfield" );
            if ( convoInput )
            {
                convoInput.focus();
                ( convoInput as HTMLTextAreaElement ).value = param;
                ( convoInput as any ).dispatchEvent(
                    new Event( "input", {
                        bubbles: true,
                        cancelable: true
                    } )
                );
            }
            setTimeout( () =>
            {
                let sendButton = document.getElementById( "kgnfqsendbutton" );
                if ( sendButton )
                {
                    console.log( "📨" );
                    ( sendButton as any ).dispatchEvent(
                        new MouseEvent( "click", {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        } )
                    );
                }
            }, 200 );
        }, 200 );
    }
}

export const getWindowTitle = (assistantName:string) : string => {
    return `kgnf ¦ ${assistantName}`
}

export const getFileCacheId = (oid:number|string) : string => {
    return `${itemCachePrepend}${oid}`
}

export const getSpaceModId = (oid:number|string) : string => {
    return `${spaceModPrepend}${oid}`
}

export const get_local_cache_selected_campaign_id_oer_space = (group_id: string): string => {
    return localStorage.getItem(`${campaignUserSelectPerSpace}${group_id}`) || "";
}

export const set_local_cache_selected_campaign_id_oer_space = (group_id: string, campaign_id: string): void => {
    localStorage.setItem(`${campaignUserSelectPerSpace}${group_id}`, campaign_id);
}

export const get_campaigns_for_selected_group = (selectedGroup: gselectedgroup): campaignidnamepair[] => {
    if (selectedGroup.campaigns_enabled == 1 && Array.isArray(selectedGroup.camp_join) && selectedGroup.camp_join.length > 0) {
        return [{ id: 'root', name: 'Default' }, ...selectedGroup.camp_join];
    }
    return [];
}

export const getActiveCampaignId = (selectedGroup: gselectedgroup, campaigns: campaignidnamepair[]): string => {
    const cached = get_local_cache_selected_campaign_id_oer_space(selectedGroup.selectionId);
    if (cached && campaigns.some(c => c.id === cached)) {
        return cached;
    } else if (selectedGroup.def_campaign_id && campaigns.some(c => c.id === selectedGroup.def_campaign_id)) {
        return selectedGroup.def_campaign_id;
    } else {
        return 'root';
    }
}
